import React, { useEffect, useState } from 'react';
import { AxiosError } from 'axios';
import {
    VStack, Box, Text, Input, Button, HStack
} from '@chakra-ui/react';
import { customAuthAxios } from '@/utils/customAuthAxios';

const InstagramDMSection = ({
                                restaurantId,
                                instagramUsername
                            }: {
    restaurantId: string;
    instagramUsername: string;
}) => {
    const [messages, setMessages] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const [replyText, setReplyText] = useState<Record<string, string>>({});

    useEffect(() => {
        const fetchUnreadMessages = async () => {
            try {
                const response = await customAuthAxios.get(`/external_api/instagram/messages/unread/${restaurantId}/`);
                const filtered = response.data.filter((msg: any) => msg.sender_name !== instagramUsername);
                setMessages(filtered);
            } catch (error) {
                console.error('DM取得エラー:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchUnreadMessages();
    }, [restaurantId, instagramUsername]);

    const handleReply = async (messageId: string, recipientId: string) => {
        const message = replyText[messageId];
        const payload = {
            recipient_id: recipientId,
            message: message,
            restaurant_id: restaurantId
        };

        console.log("📤 送信データ", payload);

        try {
            await customAuthAxios.post(`/external_api/instagram/messages/reply/`, payload);
            alert('返信しました');
            setMessages(messages.filter(msg => msg.id !== messageId));
        } catch (error) {
            const err = error as AxiosError;
            console.error("返信失敗:", err.response?.data || err.message);
            alert('返信失敗');
        }
    };
    if (loading) return <Text>DM読み込み中...</Text>;

    return (
        <VStack spacing={4} align="stretch">
            {messages.length === 0 && <Text>未返信のDMはありません。</Text>}
            {messages.map((msg) => {

                return (
                    <Box key={msg.id} borderWidth="1px" borderRadius="md" p={2} bg="gray.50">
                        <Text fontSize="sm"><strong>送信者:</strong> {msg.sender_name}</Text>
                        <Text fontSize="sm" mb={2}><strong>内容:</strong> {msg.text}</Text>
                        <HStack>
                            <Input
                                size="sm"
                                placeholder="返信内容を入力"
                                value={replyText[msg.id] || ''}
                                onChange={(e) => setReplyText({ ...replyText, [msg.id]: e.target.value })}
                            />
                            <Button
                                size="sm"
                                colorScheme="blue"
                                onClick={() => handleReply(msg.id, msg.sender_id)}
                            >
                                返信
                            </Button>
                        </HStack>
                    </Box>
                );
            })}
        </VStack>
    );
};

export default InstagramDMSection;